import { formatDate } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subject, debounceTime } from 'rxjs';
import { ActivityLogService } from 'src/app/shared/services/activity-logs-service/activity-logs.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-login-sessions',
  templateUrl: './login-sessions.component.html',
  styleUrls: ['./login-sessions.component.css'],
})
export class LoginSessionsComponent {
  loginSessionsTable: any = [];
  totalPage: any;
  totalRecords: any;
  pagination = {
    limit: 10,
    currentPage: 1,
    search: '',
    startDate: '',
    endDate: '',
  };
  private subject: Subject<string> = new Subject();
  searchForm!: FormGroup;
  constructor(
    private loginSessionService: ActivityLogService,
    private toastrMsgService: ToastrMsgService,
    private fb: FormBuilder
  ) {}

  currentDate = new Date();

  cValue = formatDate(this.currentDate, 'yyyy-MM-dd', 'en-US');
  // loginSessionsTable = [
  //   {
  //     id: 1,
  //     agentId: '10000',
  //     ip: '8.8.8.8',
  //     browser: 'demo',
  //     date: '01/01/2001',
  //   },
  //   {
  //     id: 1,
  //     agentId: '10000',
  //     ip: '8.8.8.8',
  //     browser: 'demo',
  //     date: '01/01/2001',
  //   },
  //   {
  //     id: 1,
  //     agentId: '10000',
  //     ip: '8.8.8.8',
  //     browser: 'demo',
  //     date: '01/01/2001',
  //   },
  //   {
  //     id: 1,
  //     agentId: '10000',
  //     ip: '8.8.8.8',
  //     browser: 'demo',
  //     date: '01/01/2001',
  //   },
  //   {
  //     id: 1,
  //     agentId: '10000',
  //     ip: '8.8.8.8',
  //     browser: 'demo',
  //     date: '01/01/2001',
  //   },
  // ];

  initForm() {
    this.searchForm = this.fb.group({
      search: [''],
      startDate:'',
      endDate:new FormControl(new Date().toISOString().substring(0, 10))
      // startDate: new FormControl(new Date().toISOString().substring(0, 10)),
      // endDate: new FormControl(new Date().toISOString().substring(0, 10)),

      // typeId: ['']
    });
  }
  ngOnInit() {
    this.getAllLogs(this.pagination);
    this.initForm();
    this.subject.pipe(
      debounceTime(1000)
    ).subscribe(searchTextValue => {
      this.searchApiLogs();
    });
  }
  searchApiLogs() {
    console.log(this.searchForm);
    this.searchForm.value.endDate=''
    let payload: any = {};
    payload = Object.assign({}, this.searchForm.value);
    console.log(payload, this.searchForm)
    // payload.currentPage = this.pagination.currentPage;
    payload.currentPage=1;
    payload.limit = this.pagination.limit;
    this.getAllLogs(payload);
  }
  searchApi() {
    console.log(this.searchForm);
    let payload: any = {};
    payload = Object.assign({}, this.searchForm.value);
    console.log(payload, this.searchForm)
    // payload.currentPage = this.pagination.currentPage;
    payload.currentPage=1;
    payload.limit = this.pagination.limit;
    this.getAllLogs(payload);
  }
  getAllLogs(pagination: any) {
    console.log(pagination)
    this.loginSessionService.getAPIactivityLogs(pagination).subscribe({
      next: (response: any) => {
        console.log('Get All api logs ', response.data);
        this.loginSessionsTable = response.data.data;
        this.totalPage = response.data.totalPage;
        this.totalRecords = response.data.totalData;
      },
      error: (error) => {
        console.error('Error  getting state:', error);
      },
      complete: () => {
        console.log('Get request completed');
        // clean-up logic for this
      },
    });
  }

  onKeyUp(event: any) {
    this.subject.next(event);
  }


  nextPage() {
    if (this.pagination.currentPage < this.totalPage) {
      this.pagination.currentPage++;
      this.getAllLogs(this.pagination);
    }
  }

  onPageChange(page: any) {
    this.pagination.currentPage = page;
    this.getAllLogs(this.pagination);
  }

  previousPage() {
    if (this.pagination.currentPage > 1) {
      this.pagination.currentPage--;
      this.getAllLogs(this.pagination);
    }
  }

  onLast() {
    this.pagination.currentPage = this.totalPage;
    this.getAllLogs(this.pagination);
  }
  onFirst() {
    this.pagination.currentPage = 1;
    this.getAllLogs(this.pagination);
  }

  getBrowserType(userAgent: string) {
    const test = (regexp: any) => {
      return regexp.test(userAgent);
    };

    console.log(navigator.userAgent);

    if (test(/opr\//i)) {
      return 'Opera';
    } else if (test(/edg/i)) {
      return 'Microsoft Edge';
    } else if (test(/chrome|chromium|crios/i)) {
      return 'Google Chrome';
    } else if (test(/firefox|fxios/i)) {
      return 'Mozilla Firefox';
    } else if (test(/safari/i)) {
      return 'Apple Safari';
    } else if (test(/trident/i)) {
      return 'Microsoft Internet Explorer';
    } else if (test(/ucbrowser/i)) {
      return 'UC Browser';
    } else if (test(/samsungbrowser/i)) {
      return 'Samsung Browser';
    } else {
      return 'Unknown browser';
    }
  }
}
